import { KennoFile } from '@pandiafi/design-system'
import { Field, FieldProps, FormikProps } from 'formik'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import FormFieldWrapper from 'components/FormField'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'
import { UploadFiles } from 'components/UploadFiles'

interface FilesFieldProps {
  isUploading?: (value: boolean) => void
}

export const FilesField: React.FC<FilesFieldProps> = ({
  isUploading,
}: FilesFieldProps) => {
  const { t } = useTranslation(['terminateContract'])

  const handleOnFilesUploaded = useCallback(
    (newFiles: KennoFile[], form: FormikProps<FormValues>): void => {
      const { files } = form.values
      const newValue = [...files, ...newFiles]

      form.setFieldValue('files', newValue)
    },
    []
  )

  const handleOnDeleteUploadedFile = useCallback(
    (fileToRemove: KennoFile, form: FormikProps<FormValues>): void => {
      const { files } = form.values
      const newValue = (files || []).filter((f) => f.uuid !== fileToRemove.uuid)

      form.setFieldValue('files', newValue)
    },
    []
  )

  return (
    <Field name="files">
      {({ field, meta, form }: FieldProps<FormValues['files']>) => (
        <FormFieldWrapper
          name="files"
          label={t('terminateContract:labels.files')}
          className="mt-8"
          meta={meta}
          labelBold
        >
          <UploadFiles
            id="files"
            files={field.value}
            onFilesUploaded={(newFiles) =>
              handleOnFilesUploaded(newFiles, form)
            }
            onDeleteFile={(fileToRemove) =>
              handleOnDeleteUploadedFile(fileToRemove, form)
            }
            onUploadOngoing={isUploading}
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
